import axiosInstance from "../Interceptors/ResponseInterceptor";

export function getAllOrganizations() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/organization-master/getOrganizations`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getAllDomain:", error);
      reject(error);
    }
  });
}

export const getOrgsAndRoles = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/organization-master/orgs-and-roles`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getAllRoles:", error);
      reject(error);
    }
  });
};

export const getOrgsAndCompanies = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/api/organization-master/orgs-and-companies`
      );
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getAllRoles:", error);
      reject(error);
    }
  });
};
